
export default {
  name: 'progressbar',
  components: {},
  props: {
    progress: {
      type: [Number,String],
      required: true,
      default:0,
    },
  },
  data () {
    return {
      new: this.progress,
    }
  },
  computed: {
    percentage(){
      return  `${this.new}%`;
    }
  },
  mounted () {

  },
  methods: {

  },
  watch:{
    progress : {
      handler:function(n){
        this.new = n;
      },
    }

  },
}


